export const TAB_IDS = {
  GUEST_LISTS: "guest-lists"
};
